// src/utils/checkInvoice.js
//
// Abrir el invoice de un cheque. El número nace la primera vez que se genera
// (ensureCheckInvoiceNumber), así se puede enviar al PA antes del pago.
import { ensureCheckInvoiceNumber } from '../services/claimService';
import { viewInvoice } from './invoiceGenerator';

// Devuelve el número de invoice usado. La pestaña se abre en el mismo clic,
// antes de esperar a Firestore, para que el navegador no la bloquee.
export const openCheckInvoice = async (check, { print = false } = {}) => {
  if (check.invoiceNumber) {
    viewInvoice(check, { print });
    return check.invoiceNumber;
  }
  const win = window.open('', '_blank');
  try {
    const invoiceNumber = await ensureCheckInvoiceNumber(check.id);
    viewInvoice({ ...check, invoiceNumber }, { print, win });
    return invoiceNumber;
  } catch (error) {
    if (win) win.close();
    throw error;
  }
};
